import React from "react";

export const createTableHeader = (headers) => {
  return (
    <thead>
      <tr>
        {headers.map((item) => {
          if (item.url) {
            return (
              <th
                key={item.key}
                className={`${item.class} tw-p-2.5 tw-border-b tw-border-tableBorder`}
              >
                <a href={item.url} target="_blank">
                  {item.title}{" "}
                </a>
              </th>
            );
          }
          return (
            <th
              key={item.key}
              className={`${item.class} tw-p-2.5 tw-border-b tw-border-tableBorder`}
            >
              {item.title}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export const createTableRows = (items, f) => {
  const rows = [];
  items.forEach((item, key) => {
    rows.push(f(item, key));
  });
  return rows;
};
